<template>
    <div class="container">

        <div class="card">
            <section class="hero is-primary">
                <div class="hero-body">
                    <div class="container">
                        <h1 class="title">
                            Help
                        </h1>
                    </div>
                </div>
            </section>
        </div>

        <div class="card">
            <!-- <div class=" card-header">
                <div class="card-header-title">
                    Help
                </div>
            </div> -->
            <div class="card-content">
                <Tutorial />
            </div>
        </div>

    </div>
</template>

<script>
import Tutorial from "@/components/help/Tutorial.vue";

export default {
  components: {
    Tutorial
  },

  props: {
    open: false
  }
};
</script>

<style>
</style>
